import type { FavoriteVehicle } from '@carvana/merch-contracts';
import { httpWithAuth } from '~/clients';
import { REMOVE_FAVORITE } from '~/constants/endpoints';

type DeleteFavoriteVehicleResponse = {
  content: FavoriteVehicle[];
};

export default function removeFavorite(vehicleId: number) {
  return httpWithAuth.post<DeleteFavoriteVehicleResponse>(REMOVE_FAVORITE, {
    vehicleId
  });
}
